import ReactDOM from "react-dom/client";
import React, {useEffect, useState} from "react";
import CssBaseline from '@mui/material/CssBaseline';
import Button from '@mui/material/Button';
import {createTheme, ThemeProvider, styled} from '@mui/material/styles';
import Box from '@mui/material/Box';

import {Container, Grid, Paper} from "@mui/material";
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import AppBar from '@mui/material/AppBar';

import logo from "./img/bitrix24.svg"
import fs_back from "./img/18030222_1920_1x.jpg";
import block_back from "./img/2_1x.jpg";
import {B24form} from "./components/b24form";

const root = ReactDOM.createRoot(document.getElementById("root"));
const darkTheme = createTheme({
    palette: {
        mode: 'dark',
    },
});
const App = (test) => {

    const fs_back_style = {
        position: "absolute",
        left: 0,
        top: 0,
        height: "100%",
        width: "100%",
        objectFit: "cover",
        objectPosition: "center",
        zIndex: "0"
    }
    return (
        <ThemeProvider theme={darkTheme}>
            <CssBaseline/>
            <AppBar position="sticky">
                <Box>
                    <Toolbar>

                        <Typography variant="h6" component="div">
                            <img src={logo} height={60}/>

                        </Typography>
                        <Typography variant="h6" component="div">
                            Интегро24
                        </Typography>
                        <Button color="inherit" sx={{marginLeft: "auto"}} onClick={() => {

                            document.querySelector("#bonus").scrollIntoView({
                                behavior: "smooth",
                                block: "start",
                                inline: "nearest"
                            });
                        }}>Бонусы</Button>
                        <Button color="inherit" onClick={() => {
                            document.querySelector(".b24-form").scrollIntoView({
                                behavior: "smooth",
                                block: "start",
                                inline: "nearest"
                            });
                        }}>Купить</Button>
                        <Button color="inherit" onClick={() => {
                            document.querySelector("#footer").scrollIntoView({
                                behavior: "smooth",
                                block: "start",
                                inline: "nearest"
                            });
                        }}>Контакты</Button>
                    </Toolbar>
                </Box>

            </AppBar>

            <Paper elevation={3} style={{
                padding: "15px",
                position: "relative"
            }}>
                <Container>
                    <img style={fs_back_style} src={fs_back}/>
                    <div style={{
                        background: "rgba(0,0,0,0.7)",
                        position: "absolute",
                        left: 0,
                        top: 0,
                        height: "100%",
                        width: "100%",
                    }}/>
                    <div style={{
                        position: "relative",
                        textAlign: "center"
                    }}>
                        <h1>
                            Интеграция и разработка БИТРИКС24
                        </h1>
                        <p>
                            Скидки до 30% на работы. Дополнительные бонусы.
                        </p>
                        <p>
                            Условия акции зависят от вашего тарифного плана и срока, на который вы хотите купить
                            лицензию.
                        </p>
                        <Button variant="contained" onClick={() => {
                            document.querySelector(".b24-form").scrollIntoView({
                                behavior: "smooth",
                                block: "start",
                                inline: "nearest"
                            });
                        }}>Заказать</Button>
                    </div>


                </Container>

            </Paper>

            <Container>
                <h2 id={"bonus"}>
                    БОНУСЫ ПРИ ПРОДЛЕНИИ ЛИЦЕНЗИИ
                </h2>

                <Grid container spacing={2}>
                    <Grid item lg={4} xs={12}>
                        <Paper elevation={3} style={{
                            padding: "15px",
                            height: "100%"
                        }}>
                            <h3 style={{textTransform: "uppercase"}}>1 ГОД ПРОДЛЕНИЯ</h3>
                            <p>10 часов консультаций, обучения или разработки бесплатно</p>
                        </Paper>
                    </Grid>

                    <Grid item lg={4} xs={12}>
                        <Paper elevation={3} style={{
                            padding: "15px",
                            height: "100%"
                        }}>
                            <h3 style={{textTransform: "uppercase"}}>бесплатная консультация</h3>
                            <p>Покажем, обучим, поможем подобрать оптимальное решение.</p>
                        </Paper>
                    </Grid>
                    <Grid item lg={4} xs={12}>
                        <Paper elevation={3} style={{
                            padding: "15px",
                            height: "100%"
                        }}>
                            <h3 style={{textTransform: "uppercase"}}>2 ГОД ПРОДЛЕНИЯ</h3>
                            <p>20 часов консультаций, обучения или разработки бесплатно.</p>
                        </Paper>
                    </Grid>

                    <Grid item lg={4} xs={12}>
                        <Paper elevation={3} style={{
                            padding: "15px",
                            height: "100%"
                        }}>
                            <h3 style={{textTransform: "uppercase"}}>аудит в подарок</h3>
                            <p>Проанализируем ваш бизнес и предложим оптимальное решение.</p>
                        </Paper>
                    </Grid>

                    <Grid item lg={4} xs={12}>
                        <Paper elevation={3} style={{
                            padding: "15px",
                            height: "100%"
                        }}>
                            <h3 style={{textTransform: "uppercase"}}> Надежность</h3>
                            <p>Гарантия на выполненные работы в течении всего срока, приобретения лицензии
                                Битрикс24.</p>
                        </Paper>
                    </Grid>

                    <Grid item lg={4} xs={12}>
                        <Paper elevation={3} style={{
                            padding: "15px",
                            height: "100%"
                        }}>
                            <h3 style={{textTransform: "uppercase"}}>выгодное внедрение</h3>
                            <p>Автоматизируем отдел продаж и обслуживание клиентов.</p>
                        </Paper>
                    </Grid>
                </Grid>

            </Container>
            <Paper elevation={3} style={{
                padding: "40px 0",
                position: "relative",
                marginTop: "15px",
                marginBottom: "15px"
            }}>
                <Container>
                    <img style={fs_back_style} src={block_back}/>
                    <div style={{
                        background: "rgba(0,0,0,0.7)",
                        position: "absolute",
                        left: 0,
                        top: 0,
                        height: "100%",
                        width: "100%",
                    }}/>
                    <div style={{
                        position: "relative",
                        textAlign: "center"
                    }}>
                        <h2>
                            НЕОБХОДИМА ПРЕЗЕНТАЦИЯ<br/> НАСТРОЕННОГО ФУНКЦИОНАЛА БИТРИКС24 ?
                        </h2>

                        <Button variant="contained" onClick={() => {
                            document.querySelector(".b24-form").scrollIntoView({
                                behavior: "smooth",
                                block: "start",
                                inline: "nearest"
                            });
                        }}>Оставить заявку</Button>
                    </div>


                </Container>

            </Paper>


            <B24form/>


            <Paper id={"footer"} elevation={3} style={{
                padding: "40px 0",
                position: "relative",
                marginTop: "15px"
            }}>
                <Container>
                    <Grid container spacing={2}>
                        <Grid item lg={4} xs={12}>
                            <p>ИП Быков С.А.</p>
                            <a href={"tel:+7 (911) 094-00-94"} style={{color: "#fff"}}>
                                +7 (911) 094-00-94
                            </a>
                        </Grid>
                        <Grid item lg={4} xs={12}>
                            <p>Время работы: ПН-ВС 9-19</p>
                            <Typography variant="h6" component="div">
                                © Интегро24
                            </Typography>
                        </Grid>
                    </Grid>
                </Container>

            </Paper>

        </ThemeProvider>


    )
}
root.render(
    <App/>
)